import React from "react";
import { useTranslation } from "react-i18next";
import { useBranding } from "../../context/BrandingContext";

/**
 * Minimal empty state. No suggested prompts, no resume cards, no recent-files
 * grid — just a friendly heading + subline. The chat composer sits below this
 * (rendered by the parent) and *is* the call to action.
 */
export default function WorkspaceEmptyState({ user }) {
  const { t } = useTranslation();
  const branding = useBranding();
  const appName = branding.app_name || "Faro";
  const firstName = user?.name?.split(" ")[0];

  const headline = firstName
    ? t("workspace:empty.headline_named", { name: firstName, defaultValue: "¿En qué te puedo ayudar hoy, {{name}}?" })
    : t("workspace:empty.headline", { defaultValue: "¿En qué te puedo ayudar hoy?" });

  return (
    <div className="max-w-2xl mx-auto px-6 py-16 text-center" data-testid="workspace-empty-state">
      <h2 className="font-display font-extrabold tracking-tight text-3xl lg:text-4xl">
        {headline}
      </h2>
      <p className="mt-3 text-muted-foreground">
        {t("workspace:empty.subtitle", { app: appName, defaultValue: "Escribí tu pregunta abajo o adjuntá un archivo para empezar." })}
      </p>
    </div>
  );
}
